import React from "react";

const DescriptIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 36.3954C3 38.5818 4.41884 39.9998 6.60603 39.9998L17.142 40C23.4273 40 28.5688 37.8742 32.0644 34.1528H3V36.3954ZM17.142 0.000199999L6.60603 0C4.41884 0 3 1.41819 3 3.60458V5.84717H32.0644C28.5688 2.12579 23.4273 0.000199999 17.142 0.000199999ZM26.3368 25.6995C26.3368 27.4683 27.4895 28.6159 29.2667 28.6159H35.58C36.2957 26.8407 36.7765 24.8891 37 22.7831H29.2667C27.4895 22.7831 26.3368 23.9305 26.3368 25.6995ZM17.586 14.3149C17.586 16.0839 18.7387 17.2313 20.5159 17.2313H37C36.7765 15.1253 36.2957 13.1737 35.58 11.3985H20.5159C18.7387 11.3985 17.586 12.5459 17.586 14.3149ZM20.5139 25.6995C20.5139 23.9305 19.3612 22.7831 17.584 22.7831H3V28.6159H17.584C19.3612 28.6159 20.5139 27.4685 20.5139 25.6995ZM11.7632 14.3149C11.7632 12.5459 10.6104 11.3985 8.83324 11.3985H3V17.2313H8.83324C10.6104 17.2313 11.7632 16.0839 11.7632 14.3149Z",
  fill: "#0062FF"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DescriptIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;